"use strict";
/* !!! This component is deprecated. Please do not use for new code  !!! */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var React = __importStar(require("react"));
var Menu_module_scss_1 = __importDefault(require("./Menu.module.scss"));
/**
 * @deprecated MenuHeader is deprecated. Please use draft-menu instead (it has its own menu header component).
 */
var MenuHeader = function (props) { return (React.createElement("div", { className: Menu_module_scss_1["default"].header },
    React.createElement("span", { className: Menu_module_scss_1["default"].header__title }, props.title))); };
MenuHeader.displayName = "MenuHeader";
exports["default"] = MenuHeader;
//# sourceMappingURL=MenuHeader.js.map